import axios from "axios";

const fixoConfig = {
  baseURL: "https://fixo-pjt.herokuapp.com/",
  // baseURL: "https://fixo.tk/",
};

export const fixoApi = {
  loadUser: (token) =>
    axios.get("account/accesstoken", {
      ...fixoConfig,
      headers: {
        Authorization: token,
      },
    }),
  login: (token) =>
    axios.get("account/sign-in", {
      ...fixoConfig,
      headers: {
        Authorization: token,
      },
    }),
  getCorrectData: (id) =>
    axios.get(`statement/view/${id}`, {
      ...fixoConfig,
      headers: { Authorization: sessionStorage.getItem("access_token") },
    }),

  getCorrectResult: (id) =>
    axios.get(`statement/result/${id}`, {
      ...fixoConfig,
      headers: { Authorization: sessionStorage.getItem("access_token") },
    }),

  correctorSubmit: (revisionArr, specific, type) =>
    axios.post(
      "statement/correction",
      { revisionArr, statement_id: specific, is_completed: type },
      {
        ...fixoConfig,
        headers: { Authorization: sessionStorage.getItem("access_token") },
      }
    ),
  sandEditUsersList: (dataArr) =>
    axios.post(
      "statement/write",
      { dataArr },
      {
        ...fixoConfig,
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
        },
      }
    ),
  correctorEmailSand: (correctorMail) =>
    axios.post(
      "account/auth",
      { email: correctorMail },
      {
        ...fixoConfig,
        headers: { Authorization: sessionStorage.getItem("access_token") },
      }
    ),
  correctionList: () =>
    axios.get("statement/list", {
      ...fixoConfig,
      headers: { Authorization: sessionStorage.getItem("access_token") },
    }),
  correctionListSend: () =>
    axios.post(
      "statement/list",
      {},
      {
        ...fixoConfig,
        headers: { Authorization: sessionStorage.getItem("access_token") },
      }
    ),
};
